import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IEmployeeDetailsSchema } from '../types';
import { EmployeeDetailsRow } from './employee-details-row';

const TABLE_HEAD = [
  { id: 'id', label: 'Id', align: 'center', sortable: false },
  { id: 'status', label: 'Status', align: 'center', sortable: false },
  { id: 'reason', label: 'Reason', align: 'center', sortable: false },
  { id: 'actionBy', label: 'Action By', align: 'center', sortable: false },
  { id: 'actionTime', label: 'Action Time', align: 'center', sortable: false },
  { id: 'interviewer', label: 'Interviewer', align: 'center', sortable: false },
];

interface Props {
  tableProps: TableProps;
  data?: IEmployeeDetailsSchema[];
  loading: boolean;
}

const EmployeeDetailsList = ({ tableProps, data, loading }: Props) => {
  return (
    <PaginatedTable<IEmployeeDetailsSchema>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={data}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => <EmployeeDetailsRow row={row} />}
    </PaginatedTable>
  );
};

export { EmployeeDetailsList };
